import { Button, Tooltip } from "antd";
import InfoIcon from "../../../../assets/icons/InfoIcon";
import UserIcon from "../../../../assets/icons/UserIcon";
import InfoTitle from "../../../../components/common/InfoTitle";
import EditInformationModal from "../../../../components/Settings/Leave/EditInformationModal";
import { useGetOtherSettingDataQuery } from "../../../../features/leaveProrate/leaveProrateApi";
import useError from "../../../../hooks/useError";
import useModal from "../../../../hooks/useModal";
import SidebarLayout from "../../../../layouts/SidebarLayout";
import { leaveSettingsTabList } from "./LeaveType";

export default function Others() {
  const { open, handleOpen, handleClose } = useModal<string | undefined>();
  const {
    data: otherSettingData,
    isLoading: otherSettingDataLoading,
    isError,
    error,
  } = useGetOtherSettingDataQuery();
  useError(isError, error, "Get others data fail");

  const list = [
    {
      type: "Sandwich Leave",
      status: otherSettingData?.data.others_info.sandwich_leave
        ? "Activated"
        : "Deactivated",
      tooltip: "Leave shall be deducted for even weekends and holidays",
    },
    {
      type: "Fiscal Year",
      status: otherSettingData?.data.others_info.fiscal_year,
      tooltip:
        "One year period that companies and governments use for financial reporting and budgeting",
    },
    {
      type: "Leave Prorate",
      status: otherSettingData?.data.others_info.is_leave_prorate_enable
        ? "Activated"
        : "Deactivated",
      tooltip:
        "System will be automatically prorating employee allocated yearly leave based on his/har joining date configured if this configuration is enabled",
    },
  ];

  return (
    <SidebarLayout title="Leave Settings" tabList={leaveSettingsTabList}>
      <div className="bg-white rounded-md border border-extra-light p-6">
        <InfoTitle buttonClassName="disabled:!text-neutral" icon={<UserIcon />}>
          Other Leave Settings
        </InfoTitle>
        <ul className="py-6">
          {list.map((item) => (
            <li
              className="py-2 border-b border-extra-light last:border-b-0 flex items-center"
              key={item?.type}
            >
              <h6 className="text-extra-gray text-base font-medium flex items-center gap-1.5 w-[180px]">
                {item?.type}
                <Tooltip placement="top" title={item?.tooltip}>
                  <span className="text-accent cursor-pointer">
                    <InfoIcon />
                  </span>
                </Tooltip>
              </h6>
              {otherSettingDataLoading ? (
                <div className="h-4 w-20 bg-slate-200 rounded-md"></div>
              ) : (
                <div className="text-display-body text-base font-medium">
                  {item.status}
                </div>
              )}
            </li>
          ))}
        </ul>

        <Button
          size="large"
          className="outline-button-primary !px-5 !font-semibold"
          onClick={() => {
            handleOpen({
              type: "UPDATE",
              data: otherSettingData?.data?.others_info?.fiscal_year,
            });
          }}
        >
          Edit Information
        </Button>
      </div>

      {open.type === "UPDATE" && (
        <EditInformationModal
          open={open.open}
          type={open.type}
          data={open.data}
          handleClose={handleClose}
        />
      )}
    </SidebarLayout>
  );
}
